import feedbackModule from '../scripts/feedback/feedback.module.js';
import appDependency from '../scripts/appDependency.js';
appDependency.addItem(feedbackModule);